import { useEffect } from "react";

import { SITE_URL } from "./siteConfig";
import { HERO_IMAGE } from "./siteImages";

/**
 * Lightweight SEO hook — sets <title>, description, canonical, OG and Twitter meta
 * for the current route. Falls back to values from public/index.html when props are omitted.
 */
export function useSEO({ title, description, path = "", image, imageAlt, type = "website" } = {}) {
  useEffect(() => {
    const canonical = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`.replace(/\/$/, path === "" ? "/" : "");
    const img = image || HERO_IMAGE;

    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      if (!value) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const match = selector.match(/^meta\[(name|property)="([^"]+)"\]$/);
        if (!match) return;
        el.setAttribute(match[1], match[2]);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }

    if (title) {
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }

    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[property="og:type"]', "content", type);
    setMeta('meta[property="og:image"]', "content", img);
    setMeta('meta[property="og:image:alt"]', "content", imageAlt || "Port de Monaco la nuit — Noctua Riviera livraison nocturne");
    setMeta('meta[name="twitter:image"]', "content", img);

    // Canonical link
    let canonicalEl = document.head.querySelector('link[rel="canonical"]');
    if (!canonicalEl) {
      canonicalEl = document.createElement("link");
      canonicalEl.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute("href", canonical);
  }, [title, description, path, image, imageAlt, type]);
}
